/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as VerifyEmailRouteImport } from "./routes/verify-email"
import { Route as TwoFactorRouteImport } from "./routes/two-factor"
import { Route as ResetPasswordRouteImport } from "./routes/reset-password"
import { Route as LoginRouteImport } from "./routes/login"
import { Route as ForgotPasswordRouteImport } from "./routes/forgot-password"
import { Route as AcceptInviteRouteImport } from "./routes/accept-invite"
import { Route as AppRouteImport } from "./routes/_app"
import { Route as AppIndexRouteImport } from "./routes/_app/index"
import { Route as AppOnboardingRouteImport } from "./routes/_app/onboarding"
import { Route as AppCycleRouteImport } from "./routes/_app/cycle"
import { Route as AppAttentionRouteImport } from "./routes/_app/attention"
import { Route as AppSettingsIndexRouteImport } from "./routes/_app/settings/index"
import { Route as AppReportsIndexRouteImport } from "./routes/_app/reports/index"
import { Route as AppInvoicesIndexRouteImport } from "./routes/_app/invoices/index"
import { Route as AppDocumentsIndexRouteImport } from "./routes/_app/documents/index"
import { Route as AppCustomersIndexRouteImport } from "./routes/_app/customers/index"
import { Route as AppSettingsTeamRouteImport } from "./routes/_app/settings/team"
import { Route as AppSettingsSecurityRouteImport } from "./routes/_app/settings/security"
import { Route as AppSettingsQuickbooksRouteImport } from "./routes/_app/settings/quickbooks"
import { Route as AppSettingsProfileRouteImport } from "./routes/_app/settings/profile"
import { Route as AppSettingsNotificationsRouteImport } from "./routes/_app/settings/notifications"
import { Route as AppSettingsInvoicingRouteImport } from "./routes/_app/settings/invoicing"
import { Route as AppSettingsDangerZoneRouteImport } from "./routes/_app/settings/danger-zone"
import { Route as AppSettingsCustomerMappingRouteImport } from "./routes/_app/settings/customer-mapping"
import { Route as AppInvoicesReviewRouteImport } from "./routes/_app/invoices/review"
import { Route as AppInvoicesGenerateRouteImport } from "./routes/_app/invoices/generate"
import { Route as AppInvoicesInvoiceIdRouteImport } from "./routes/_app/invoices/$invoiceId"
import { Route as AppDocumentsDocumentIdRouteImport } from "./routes/_app/documents/$documentId"
import { Route as AppCustomersCustomerIdRouteImport } from "./routes/_app/customers/$customerId"

const VerifyEmailRoute = VerifyEmailRouteImport.update({
  id: "/verify-email",
  path: "/verify-email",
  getParentRoute: () => rootRouteImport,
} as any)
const TwoFactorRoute = TwoFactorRouteImport.update({
  id: "/two-factor",
  path: "/two-factor",
  getParentRoute: () => rootRouteImport,
} as any)
const ResetPasswordRoute = ResetPasswordRouteImport.update({
  id: "/reset-password",
  path: "/reset-password",
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: "/forgot-password",
  path: "/forgot-password",
  getParentRoute: () => rootRouteImport,
} as any)
const AcceptInviteRoute = AcceptInviteRouteImport.update({
  id: "/accept-invite",
  path: "/accept-invite",
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: "/_app",
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppRoute,
} as any)
const AppOnboardingRoute = AppOnboardingRouteImport.update({
  id: "/onboarding",
  path: "/onboarding",
  getParentRoute: () => AppRoute,
} as any)
const AppCycleRoute = AppCycleRouteImport.update({
  id: "/cycle",
  path: "/cycle",
  getParentRoute: () => AppRoute,
} as any)
const AppAttentionRoute = AppAttentionRouteImport.update({
  id: "/attention",
  path: "/attention",
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsIndexRoute = AppSettingsIndexRouteImport.update({
  id: "/settings/",
  path: "/settings/",
  getParentRoute: () => AppRoute,
} as any)
const AppReportsIndexRoute = AppReportsIndexRouteImport.update({
  id: "/reports/",
  path: "/reports/",
  getParentRoute: () => AppRoute,
} as any)
const AppInvoicesIndexRoute = AppInvoicesIndexRouteImport.update({
  id: "/invoices/",
  path: "/invoices/",
  getParentRoute: () => AppRoute,
} as any)
const AppDocumentsIndexRoute = AppDocumentsIndexRouteImport.update({
  id: "/documents/",
  path: "/documents/",
  getParentRoute: () => AppRoute,
} as any)
const AppCustomersIndexRoute = AppCustomersIndexRouteImport.update({
  id: "/customers/",
  path: "/customers/",
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsTeamRoute = AppSettingsTeamRouteImport.update({
  id: "/settings/team",
  path: "/settings/team",
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsSecurityRoute = AppSettingsSecurityRouteImport.update({
  id: "/settings/security",
  path: "/settings/security",
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsQuickbooksRoute = AppSettingsQuickbooksRouteImport.update({
  id: "/settings/quickbooks",
  path: "/settings/quickbooks",
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsProfileRoute = AppSettingsProfileRouteImport.update({
  id: "/settings/profile",
  path: "/settings/profile",
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import("./routes/_app/settings/profile.lazy").then((d) => d.Route),
)
const AppSettingsNotificationsRoute =
  AppSettingsNotificationsRouteImport.update({
    id: "/settings/notifications",
    path: "/settings/notifications",
    getParentRoute: () => AppRoute,
  } as any)
const AppSettingsInvoicingRoute = AppSettingsInvoicingRouteImport.update({
  id: "/settings/invoicing",
  path: "/settings/invoicing",
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsDangerZoneRoute = AppSettingsDangerZoneRouteImport.update({
  id: "/settings/danger-zone",
  path: "/settings/danger-zone",
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsCustomerMappingRoute =
  AppSettingsCustomerMappingRouteImport.update({
    id: "/settings/customer-mapping",
    path: "/settings/customer-mapping",
    getParentRoute: () => AppRoute,
  } as any)
const AppInvoicesReviewRoute = AppInvoicesReviewRouteImport.update({
  id: "/invoices/review",
  path: "/invoices/review",
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import("./routes/_app/invoices/review.lazy").then((d) => d.Route),
)
const AppInvoicesGenerateRoute = AppInvoicesGenerateRouteImport.update({
  id: "/invoices/generate",
  path: "/invoices/generate",
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import("./routes/_app/invoices/generate.lazy").then((d) => d.Route),
)
const AppInvoicesInvoiceIdRoute = AppInvoicesInvoiceIdRouteImport.update({
  id: "/invoices/$invoiceId",
  path: "/invoices/$invoiceId",
  getParentRoute: () => AppRoute,
} as any)
const AppDocumentsDocumentIdRoute = AppDocumentsDocumentIdRouteImport.update({
  id: "/documents/$documentId",
  path: "/documents/$documentId",
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import("./routes/_app/documents/$documentId.lazy").then((d) => d.Route),
)
const AppCustomersCustomerIdRoute = AppCustomersCustomerIdRouteImport.update({
  id: "/customers/$customerId",
  path: "/customers/$customerId",
  getParentRoute: () => AppRoute,
} as any).lazy(() =>
  import("./routes/_app/customers/$customerId.lazy").then((d) => d.Route),
)

export interface FileRoutesByFullPath {
  "/": typeof AppIndexRoute
  "/accept-invite": typeof AcceptInviteRoute
  "/forgot-password": typeof ForgotPasswordRoute
  "/login": typeof LoginRoute
  "/reset-password": typeof ResetPasswordRoute
  "/two-factor": typeof TwoFactorRoute
  "/verify-email": typeof VerifyEmailRoute
  "/attention": typeof AppAttentionRoute
  "/cycle": typeof AppCycleRoute
  "/onboarding": typeof AppOnboardingRoute
  "/customers/$customerId": typeof AppCustomersCustomerIdRoute
  "/documents/$documentId": typeof AppDocumentsDocumentIdRoute
  "/invoices/$invoiceId": typeof AppInvoicesInvoiceIdRoute
  "/invoices/generate": typeof AppInvoicesGenerateRoute
  "/invoices/review": typeof AppInvoicesReviewRoute
  "/settings/customer-mapping": typeof AppSettingsCustomerMappingRoute
  "/settings/danger-zone": typeof AppSettingsDangerZoneRoute
  "/settings/invoicing": typeof AppSettingsInvoicingRoute
  "/settings/notifications": typeof AppSettingsNotificationsRoute
  "/settings/profile": typeof AppSettingsProfileRoute
  "/settings/quickbooks": typeof AppSettingsQuickbooksRoute
  "/settings/security": typeof AppSettingsSecurityRoute
  "/settings/team": typeof AppSettingsTeamRoute
  "/customers/": typeof AppCustomersIndexRoute
  "/documents/": typeof AppDocumentsIndexRoute
  "/invoices/": typeof AppInvoicesIndexRoute
  "/reports/": typeof AppReportsIndexRoute
  "/settings/": typeof AppSettingsIndexRoute
}
export interface FileRoutesByTo {
  "/accept-invite": typeof AcceptInviteRoute
  "/forgot-password": typeof ForgotPasswordRoute
  "/login": typeof LoginRoute
  "/reset-password": typeof ResetPasswordRoute
  "/two-factor": typeof TwoFactorRoute
  "/verify-email": typeof VerifyEmailRoute
  "/attention": typeof AppAttentionRoute
  "/cycle": typeof AppCycleRoute
  "/onboarding": typeof AppOnboardingRoute
  "/": typeof AppIndexRoute
  "/customers/$customerId": typeof AppCustomersCustomerIdRoute
  "/documents/$documentId": typeof AppDocumentsDocumentIdRoute
  "/invoices/$invoiceId": typeof AppInvoicesInvoiceIdRoute
  "/invoices/generate": typeof AppInvoicesGenerateRoute
  "/invoices/review": typeof AppInvoicesReviewRoute
  "/settings/customer-mapping": typeof AppSettingsCustomerMappingRoute
  "/settings/danger-zone": typeof AppSettingsDangerZoneRoute
  "/settings/invoicing": typeof AppSettingsInvoicingRoute
  "/settings/notifications": typeof AppSettingsNotificationsRoute
  "/settings/profile": typeof AppSettingsProfileRoute
  "/settings/quickbooks": typeof AppSettingsQuickbooksRoute
  "/settings/security": typeof AppSettingsSecurityRoute
  "/settings/team": typeof AppSettingsTeamRoute
  "/customers": typeof AppCustomersIndexRoute
  "/documents": typeof AppDocumentsIndexRoute
  "/invoices": typeof AppInvoicesIndexRoute
  "/reports": typeof AppReportsIndexRoute
  "/settings": typeof AppSettingsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/_app": typeof AppRouteWithChildren
  "/accept-invite": typeof AcceptInviteRoute
  "/forgot-password": typeof ForgotPasswordRoute
  "/login": typeof LoginRoute
  "/reset-password": typeof ResetPasswordRoute
  "/two-factor": typeof TwoFactorRoute
  "/verify-email": typeof VerifyEmailRoute
  "/_app/attention": typeof AppAttentionRoute
  "/_app/cycle": typeof AppCycleRoute
  "/_app/onboarding": typeof AppOnboardingRoute
  "/_app/": typeof AppIndexRoute
  "/_app/customers/$customerId": typeof AppCustomersCustomerIdRoute
  "/_app/documents/$documentId": typeof AppDocumentsDocumentIdRoute
  "/_app/invoices/$invoiceId": typeof AppInvoicesInvoiceIdRoute
  "/_app/invoices/generate": typeof AppInvoicesGenerateRoute
  "/_app/invoices/review": typeof AppInvoicesReviewRoute
  "/_app/settings/customer-mapping": typeof AppSettingsCustomerMappingRoute
  "/_app/settings/danger-zone": typeof AppSettingsDangerZoneRoute
  "/_app/settings/invoicing": typeof AppSettingsInvoicingRoute
  "/_app/settings/notifications": typeof AppSettingsNotificationsRoute
  "/_app/settings/profile": typeof AppSettingsProfileRoute
  "/_app/settings/quickbooks": typeof AppSettingsQuickbooksRoute
  "/_app/settings/security": typeof AppSettingsSecurityRoute
  "/_app/settings/team": typeof AppSettingsTeamRoute
  "/_app/customers/": typeof AppCustomersIndexRoute
  "/_app/documents/": typeof AppDocumentsIndexRoute
  "/_app/invoices/": typeof AppInvoicesIndexRoute
  "/_app/reports/": typeof AppReportsIndexRoute
  "/_app/settings/": typeof AppSettingsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/accept-invite"
    | "/forgot-password"
    | "/login"
    | "/reset-password"
    | "/two-factor"
    | "/verify-email"
    | "/attention"
    | "/cycle"
    | "/onboarding"
    | "/customers/$customerId"
    | "/documents/$documentId"
    | "/invoices/$invoiceId"
    | "/invoices/generate"
    | "/invoices/review"
    | "/settings/customer-mapping"
    | "/settings/danger-zone"
    | "/settings/invoicing"
    | "/settings/notifications"
    | "/settings/profile"
    | "/settings/quickbooks"
    | "/settings/security"
    | "/settings/team"
    | "/customers/"
    | "/documents/"
    | "/invoices/"
    | "/reports/"
    | "/settings/"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/accept-invite"
    | "/forgot-password"
    | "/login"
    | "/reset-password"
    | "/two-factor"
    | "/verify-email"
    | "/attention"
    | "/cycle"
    | "/onboarding"
    | "/"
    | "/customers/$customerId"
    | "/documents/$documentId"
    | "/invoices/$invoiceId"
    | "/invoices/generate"
    | "/invoices/review"
    | "/settings/customer-mapping"
    | "/settings/danger-zone"
    | "/settings/invoicing"
    | "/settings/notifications"
    | "/settings/profile"
    | "/settings/quickbooks"
    | "/settings/security"
    | "/settings/team"
    | "/customers"
    | "/documents"
    | "/invoices"
    | "/reports"
    | "/settings"
  id:
    | "__root__"
    | "/_app"
    | "/accept-invite"
    | "/forgot-password"
    | "/login"
    | "/reset-password"
    | "/two-factor"
    | "/verify-email"
    | "/_app/attention"
    | "/_app/cycle"
    | "/_app/onboarding"
    | "/_app/"
    | "/_app/customers/$customerId"
    | "/_app/documents/$documentId"
    | "/_app/invoices/$invoiceId"
    | "/_app/invoices/generate"
    | "/_app/invoices/review"
    | "/_app/settings/customer-mapping"
    | "/_app/settings/danger-zone"
    | "/_app/settings/invoicing"
    | "/_app/settings/notifications"
    | "/_app/settings/profile"
    | "/_app/settings/quickbooks"
    | "/_app/settings/security"
    | "/_app/settings/team"
    | "/_app/customers/"
    | "/_app/documents/"
    | "/_app/invoices/"
    | "/_app/reports/"
    | "/_app/settings/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  AcceptInviteRoute: typeof AcceptInviteRoute
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  ResetPasswordRoute: typeof ResetPasswordRoute
  TwoFactorRoute: typeof TwoFactorRoute
  VerifyEmailRoute: typeof VerifyEmailRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/verify-email": {
      id: "/verify-email"
      path: "/verify-email"
      fullPath: "/verify-email"
      preLoaderRoute: typeof VerifyEmailRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/two-factor": {
      id: "/two-factor"
      path: "/two-factor"
      fullPath: "/two-factor"
      preLoaderRoute: typeof TwoFactorRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/reset-password": {
      id: "/reset-password"
      path: "/reset-password"
      fullPath: "/reset-password"
      preLoaderRoute: typeof ResetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/login": {
      id: "/login"
      path: "/login"
      fullPath: "/login"
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/forgot-password": {
      id: "/forgot-password"
      path: "/forgot-password"
      fullPath: "/forgot-password"
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/accept-invite": {
      id: "/accept-invite"
      path: "/accept-invite"
      fullPath: "/accept-invite"
      preLoaderRoute: typeof AcceptInviteRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_app": {
      id: "/_app"
      path: ""
      fullPath: "/"
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_app/": {
      id: "/_app/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/onboarding": {
      id: "/_app/onboarding"
      path: "/onboarding"
      fullPath: "/onboarding"
      preLoaderRoute: typeof AppOnboardingRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/cycle": {
      id: "/_app/cycle"
      path: "/cycle"
      fullPath: "/cycle"
      preLoaderRoute: typeof AppCycleRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/attention": {
      id: "/_app/attention"
      path: "/attention"
      fullPath: "/attention"
      preLoaderRoute: typeof AppAttentionRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/settings/": {
      id: "/_app/settings/"
      path: "/settings"
      fullPath: "/settings/"
      preLoaderRoute: typeof AppSettingsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/reports/": {
      id: "/_app/reports/"
      path: "/reports"
      fullPath: "/reports/"
      preLoaderRoute: typeof AppReportsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/invoices/": {
      id: "/_app/invoices/"
      path: "/invoices"
      fullPath: "/invoices/"
      preLoaderRoute: typeof AppInvoicesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/documents/": {
      id: "/_app/documents/"
      path: "/documents"
      fullPath: "/documents/"
      preLoaderRoute: typeof AppDocumentsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/customers/": {
      id: "/_app/customers/"
      path: "/customers"
      fullPath: "/customers/"
      preLoaderRoute: typeof AppCustomersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/settings/team": {
      id: "/_app/settings/team"
      path: "/settings/team"
      fullPath: "/settings/team"
      preLoaderRoute: typeof AppSettingsTeamRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/settings/security": {
      id: "/_app/settings/security"
      path: "/settings/security"
      fullPath: "/settings/security"
      preLoaderRoute: typeof AppSettingsSecurityRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/settings/quickbooks": {
      id: "/_app/settings/quickbooks"
      path: "/settings/quickbooks"
      fullPath: "/settings/quickbooks"
      preLoaderRoute: typeof AppSettingsQuickbooksRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/settings/profile": {
      id: "/_app/settings/profile"
      path: "/settings/profile"
      fullPath: "/settings/profile"
      preLoaderRoute: typeof AppSettingsProfileRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/settings/notifications": {
      id: "/_app/settings/notifications"
      path: "/settings/notifications"
      fullPath: "/settings/notifications"
      preLoaderRoute: typeof AppSettingsNotificationsRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/settings/invoicing": {
      id: "/_app/settings/invoicing"
      path: "/settings/invoicing"
      fullPath: "/settings/invoicing"
      preLoaderRoute: typeof AppSettingsInvoicingRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/settings/danger-zone": {
      id: "/_app/settings/danger-zone"
      path: "/settings/danger-zone"
      fullPath: "/settings/danger-zone"
      preLoaderRoute: typeof AppSettingsDangerZoneRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/settings/customer-mapping": {
      id: "/_app/settings/customer-mapping"
      path: "/settings/customer-mapping"
      fullPath: "/settings/customer-mapping"
      preLoaderRoute: typeof AppSettingsCustomerMappingRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/invoices/review": {
      id: "/_app/invoices/review"
      path: "/invoices/review"
      fullPath: "/invoices/review"
      preLoaderRoute: typeof AppInvoicesReviewRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/invoices/generate": {
      id: "/_app/invoices/generate"
      path: "/invoices/generate"
      fullPath: "/invoices/generate"
      preLoaderRoute: typeof AppInvoicesGenerateRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/invoices/$invoiceId": {
      id: "/_app/invoices/$invoiceId"
      path: "/invoices/$invoiceId"
      fullPath: "/invoices/$invoiceId"
      preLoaderRoute: typeof AppInvoicesInvoiceIdRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/documents/$documentId": {
      id: "/_app/documents/$documentId"
      path: "/documents/$documentId"
      fullPath: "/documents/$documentId"
      preLoaderRoute: typeof AppDocumentsDocumentIdRouteImport
      parentRoute: typeof AppRoute
    }
    "/_app/customers/$customerId": {
      id: "/_app/customers/$customerId"
      path: "/customers/$customerId"
      fullPath: "/customers/$customerId"
      preLoaderRoute: typeof AppCustomersCustomerIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppAttentionRoute: typeof AppAttentionRoute
  AppCycleRoute: typeof AppCycleRoute
  AppOnboardingRoute: typeof AppOnboardingRoute
  AppIndexRoute: typeof AppIndexRoute
  AppCustomersCustomerIdRoute: typeof AppCustomersCustomerIdRoute
  AppDocumentsDocumentIdRoute: typeof AppDocumentsDocumentIdRoute
  AppInvoicesInvoiceIdRoute: typeof AppInvoicesInvoiceIdRoute
  AppInvoicesGenerateRoute: typeof AppInvoicesGenerateRoute
  AppInvoicesReviewRoute: typeof AppInvoicesReviewRoute
  AppSettingsCustomerMappingRoute: typeof AppSettingsCustomerMappingRoute
  AppSettingsDangerZoneRoute: typeof AppSettingsDangerZoneRoute
  AppSettingsInvoicingRoute: typeof AppSettingsInvoicingRoute
  AppSettingsNotificationsRoute: typeof AppSettingsNotificationsRoute
  AppSettingsProfileRoute: typeof AppSettingsProfileRoute
  AppSettingsQuickbooksRoute: typeof AppSettingsQuickbooksRoute
  AppSettingsSecurityRoute: typeof AppSettingsSecurityRoute
  AppSettingsTeamRoute: typeof AppSettingsTeamRoute
  AppCustomersIndexRoute: typeof AppCustomersIndexRoute
  AppDocumentsIndexRoute: typeof AppDocumentsIndexRoute
  AppInvoicesIndexRoute: typeof AppInvoicesIndexRoute
  AppReportsIndexRoute: typeof AppReportsIndexRoute
  AppSettingsIndexRoute: typeof AppSettingsIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppAttentionRoute: AppAttentionRoute,
  AppCycleRoute: AppCycleRoute,
  AppOnboardingRoute: AppOnboardingRoute,
  AppIndexRoute: AppIndexRoute,
  AppCustomersCustomerIdRoute: AppCustomersCustomerIdRoute,
  AppDocumentsDocumentIdRoute: AppDocumentsDocumentIdRoute,
  AppInvoicesInvoiceIdRoute: AppInvoicesInvoiceIdRoute,
  AppInvoicesGenerateRoute: AppInvoicesGenerateRoute,
  AppInvoicesReviewRoute: AppInvoicesReviewRoute,
  AppSettingsCustomerMappingRoute: AppSettingsCustomerMappingRoute,
  AppSettingsDangerZoneRoute: AppSettingsDangerZoneRoute,
  AppSettingsInvoicingRoute: AppSettingsInvoicingRoute,
  AppSettingsNotificationsRoute: AppSettingsNotificationsRoute,
  AppSettingsProfileRoute: AppSettingsProfileRoute,
  AppSettingsQuickbooksRoute: AppSettingsQuickbooksRoute,
  AppSettingsSecurityRoute: AppSettingsSecurityRoute,
  AppSettingsTeamRoute: AppSettingsTeamRoute,
  AppCustomersIndexRoute: AppCustomersIndexRoute,
  AppDocumentsIndexRoute: AppDocumentsIndexRoute,
  AppInvoicesIndexRoute: AppInvoicesIndexRoute,
  AppReportsIndexRoute: AppReportsIndexRoute,
  AppSettingsIndexRoute: AppSettingsIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  AcceptInviteRoute: AcceptInviteRoute,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  ResetPasswordRoute: ResetPasswordRoute,
  TwoFactorRoute: TwoFactorRoute,
  VerifyEmailRoute: VerifyEmailRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
